import React from "react";
import { useMutation } from "react-query";
import { deactivateOfficeBank } from "../../../../../actions/Utilities/OfficeBank";

const useDeleteOfficeBank = () => {
  return useMutation(deactivateOfficeBank);
};

export default useDeleteOfficeBank;
